import React, { DispatchWithoutAction } from 'react'

import { loginReducer } from './loginReducer'
import { AuthorizationRoles, AuthPermissions } from '../Utilities/enum'

export type AppState = {
  accessToken?: string
  tenant: { name: string; id?: string }
  user: { name: string }
  permissions: AuthPermissions[]
  role?: AuthorizationRoles
}

export const initialState: AppState = {
  accessToken: undefined,
  tenant: { name: '', id: undefined },
  user: { name: '' },
  permissions: [],
  role: undefined,
}

const AppStateContext = React.createContext(initialState)
const AppDispatchContext = React.createContext(() => {})

export const AppProvider: React.FunctionComponent = ({ children }) => {
  const [state, dispatch] = React.useReducer(loginReducer, initialState)

  return (
    <AppStateContext.Provider value={state}>
      <AppDispatchContext.Provider value={dispatch}>
        {children}
      </AppDispatchContext.Provider>
    </AppStateContext.Provider>
  )
}

export function useAppState() {
  const context = React.useContext<AppState>(AppStateContext)
  if (!context) {
    throw new Error('useAppState must be used within the App Provider')
  }
  return context
}

export function useAppDispatch() {
  const context = React.useContext<DispatchWithoutAction>(AppDispatchContext)
  if (!context) {
    throw new Error('useAppDispatch must be used within AppProvider')
  }
  return context
}
